// Angular strap's dropdown does not seem to be working properly when using an object.
export const ftpDropdownComponent = {
    name: 'ftpDropdown',
    transclude: true,
    template: `
    <button type="button" 
        class="ftp-dropdown" 
        bs-dropdown="$ctrl.dropdown.data"
        data-animation="am-flip-x"  
        aria-haspopup="true" 
        aria-expanded="false">
        <ng-transclude></ng-transclude>
    </button>
    `,
    bindings: {
        dropdown: '<',
    },
    controller: function () {
        'ngInject';
        const ctrl = this;
    },
};
